export const SLA_TO_BUSINESS_DAYS = {
  Standard: 4,
  "Business Lite": 3,
  Business: 2,
  Gold: 1,
};

export const BUSINESS_END_HOUR = 17;

export const EDT_ELIGIBLE_STATUSES = ["locked", "approval", "delivering"];

export function isValidEstimatedDeliveryTime(value) {
  if (value == null || value === "") {
    return false;
  }
  const date = new Date(value);
  return !Number.isNaN(date.getTime());
}

/** Return a Date at 17:00 on the Nth future business day (today is not counted). */
export function calculateBusinessDaysFromNow(slaLevel, now = new Date()) {
  const businessDays = SLA_TO_BUSINESS_DAYS[slaLevel] ?? 4;
  const dt = new Date(now);

  let added = 0;
  while (added < businessDays) {
    dt.setDate(dt.getDate() + 1);
    const weekday = dt.getDay();
    if (weekday >= 1 && weekday <= 5) {
      added += 1;
    }
  }

  dt.setHours(BUSINESS_END_HOUR, 0, 0, 0);
  return dt;
}

export function countBusinessDaysUntil(endDate, fromDate = new Date()) {
  const end = new Date(endDate);
  if (Number.isNaN(end.getTime())) {
    return 0;
  }

  end.setHours(0, 0, 0, 0);
  const current = new Date(fromDate);
  current.setHours(0, 0, 0, 0);
  current.setDate(current.getDate() + 1);

  let businessDays = 0;
  while (current <= end) {
    const dayOfWeek = current.getDay();
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      businessDays += 1;
    }
    current.setDate(current.getDate() + 1);
  }

  return businessDays;
}

export function enrichReleaseEstimatedDelivery(release, slaLevel) {
  if (!release || !EDT_ELIGIBLE_STATUSES.includes(release.status)) {
    return release;
  }

  if (isValidEstimatedDeliveryTime(release.estimated_delivery_time)) {
    return release;
  }

  return {
    ...release,
    estimated_delivery_time: calculateBusinessDaysFromNow(slaLevel).toISOString(),
  };
}
